import {
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  inject, PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import {HeaderComponent} from "../../common/header/header.component";
import {FooterComponent} from "../../common/footer/footer.component";
import {RouterLink} from "@angular/router";
import {
   IonContent, IonImg, IonSkeletonText, IonText
} from "@ionic/angular/standalone";
import {addIcons} from "ionicons";
import {home, settings, person, people, homeOutline, settingsOutline, personOutline, peopleOutline} from "ionicons/icons";
import {PropertyService} from "../../properties/property.service";
import {FilterComponent} from "../../common/filter/filter.component";
// MapInfoWindow removed - not used on home page
import {CurrencyPipe, isPlatformBrowser} from "@angular/common";
import {FormsModule} from '@angular/forms';
import {HomeAboutComponent} from './components/home-about/home-about.component';
import {HomePropertyComponent} from './components/home-property/home-property.component';
import {SatelInNumbersV2Component} from './components/satel-in-numbers-v2/satel-in-numbers-v2.component';
import {HomeBannerOptimizedComponent} from './components/home-banner-optimized/home-banner-optimized.component';
import {TestimonialComponent} from './components/testimonial/testimonial.component';
import {TranslatePipe} from '@ngx-translate/core';


@Component({
    selector: 'app-home',
  imports: [
    HeaderComponent,
    FooterComponent,
    RouterLink,
    IonContent,
    FilterComponent,
    IonImg,
    FormsModule,
    IonText,
    IonSkeletonText,
    HomeAboutComponent,
    HomePropertyComponent,
    HomeBannerOptimizedComponent,
    SatelInNumbersV2Component,
    TestimonialComponent,
    TranslatePipe,
  ],
    providers: [CurrencyPipe],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss',
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HomeComponent implements AfterViewInit {
  @ViewChild('videoBanner') videoBanner!: ElementRef;
  @ViewChild('videoEle') videoEle!: ElementRef;
  isScrolled = false;
  isHome = false;
  properties: any = [];
  propertyPins: any = [];
  propertyService: PropertyService = inject(PropertyService);

  breakpointsPartners = {
    100: {
      slidesPerView: 4
    },
    640: {
      slidesPerView: 4,
    },
    1024: {
      slidesPerView: 6,
    },
  }
  private platformId = inject(PLATFORM_ID);
  private isBrowser = isPlatformBrowser(this.platformId);

  constructor() {
    addIcons({ home, homeOutline, settings, settingsOutline, person, personOutline, people, peopleOutline });
  }
  initialDataLoaded: boolean = false;
  loadContent: boolean = false;
  async ngAfterViewInit() {
    // Use requestIdleCallback for non-blocking content load, with 500ms timeout fallback
    const loadContentCallback = () => {
      this.loadContent = true;
      if (this.isBrowser) {
        this.videoEle?.nativeElement.play();
      }
    };
    if (this.isBrowser) {
      if ('requestIdleCallback' in window) {
        (window as any).requestIdleCallback(loadContentCallback, { timeout: 500 });
      } else {
        setTimeout(loadContentCallback, 500);
      }
    } else {
      // SSR: no `window`; show deferred content without video APIs
      this.loadContent = true;
    }

    if (this.isBrowser) {
      // Lazy-load list-your-property videos
      const videos = document.querySelectorAll('.list-your-property-video') as NodeListOf<HTMLVideoElement>;
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const video = entry.target as HTMLVideoElement;
              video.load();
              obs.unobserve(video);
            }
          });
        }, {threshold: 0.1});
        videos.forEach(video => observer.observe(video));
      } else {
        // Fallback: load all videos immediately
        videos.forEach(video => video.load());
      }
    }
    this.loadSwiper();
  }

  async loadSwiper() {
    const { register } = await import('swiper/element/bundle');
    register();
  }


  async onScroll($event: any) {
    this.isScrolled = $event.detail.scrollTop > 50;
    this.isHome = $event.detail.scrollTop > 50;
    if ($event.detail.scrollTop > 5) {
      this.loadContent = true;
    }
    if (!this.showChat && $event.detail.scrollTop >= 300) {
      this.showChat = true;
    }
    if ($event.detail.scrollTop > 50 && !this.initialDataLoaded) {
      this.initialDataLoaded = true;
      this.loadingProperties = true;
      try {
        const listRes = await this.propertyService.getProperties({ limit: 8, ver: 2 });
        this.properties = this.propertyService.unwrapFilterListResult(listRes);
        const mapRes = await this.propertyService.getProperties({ map: true });
        this.propertyPins = Array.isArray(mapRes) ? mapRes : this.propertyService.unwrapFilterListResult(mapRes);
      } finally {
        this.loadingProperties = false;
      }
    }
  }


  appDownloadImageLoaded = false;
  loadingProperties: boolean = true;
  showChat: boolean = false;
}
